import * as React from 'react'
import styled from 'styled-components'

const Hud = styled.div`
  position: fixed;
  top: 12px;
  right: 12px;
  z-index: 6;
  display: flex;
  align-items: center;
  gap: 8px;
  pointer-events: none;
`

const HomeButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 48px;
  height: 22px;
  padding: 0 8px;
  border: 1px solid #ffffff;
  border-radius: 5px;
  background: #000000;
  box-shadow:
    0 0 0 1px #000000,
    0 8px 18px rgba(0, 0, 0, 0.42);
  color: #ffffff;
  cursor: pointer;
  font-family: 'IBM Plex Mono', 'Consolas', 'SFMono-Regular', monospace;
  font-size: 0.64rem;
  font-weight: 800;
  letter-spacing: 0;
  line-height: 1;
  pointer-events: auto;

  &:hover {
    color: #7cff00;
  }

  &:focus-visible {
    outline: 2px solid rgba(124, 255, 0, 0.48);
    outline-offset: 2px;
  }
`

const Counter = styled.output`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 50px;
  height: 22px;
  padding: 0 6px;
  border: 1px solid #ffffff;
  border-radius: 5px;
  background: #000000;
  box-shadow:
    0 0 0 1px #000000,
    0 8px 18px rgba(0, 0, 0, 0.42);
  color: #7cff00;
  font-family: 'IBM Plex Mono', 'Consolas', 'SFMono-Regular', monospace;
  font-size: 0.64rem;
  font-weight: 800;
  line-height: 1;
  letter-spacing: 0;
  text-shadow: 0 0 8px rgba(124, 255, 0, 0.52);
`

type Props = {
  onHomeClick?: () => void
  showHomeButton?: boolean
}

export const FpsCounter = ({ onHomeClick, showHomeButton = false }: Props) => {
  const [fps, setFps] = React.useState(0)

  React.useEffect(() => {
    let frameId = 0
    let frames = 0
    let lastSampleTime = performance.now()

    const sample = (timestamp: number) => {
      frames += 1

      const elapsed = timestamp - lastSampleTime

      if (elapsed >= 500) {
        setFps(Math.round((frames * 1000) / elapsed))
        frames = 0
        lastSampleTime = timestamp
      }

      frameId = window.requestAnimationFrame(sample)
    }

    frameId = window.requestAnimationFrame(sample)

    return () => window.cancelAnimationFrame(frameId)
  }, [])

  return (
    <Hud>
      {showHomeButton && onHomeClick ? (
        <HomeButton type="button" aria-label="Back to home" onClick={onHomeClick}>
          Home
        </HomeButton>
      ) : null}
      <Counter aria-label={`FPS ${fps}`}>{fps} FPS</Counter>
    </Hud>
  )
}
